import {z} from 'zod';

import {
  SalesActivityRelatedCallResponseBodySchema,
  SalesActivityRelatedMessageResponseBodySchema,
  SalesActivityRelatedTaskResponseBodySchema,
} from '@dms/api/sales';

export const DirectSaleManualActivityKindSchema = z.enum([
  'CALL_FROM_CUSTOMER',
  'CALL_TO_CUSTOMER',
  'MESSAGE_FROM_CUSTOMER',
  'MESSAGE_TO_CUSTOMER',
  'CUSTOMER_VISIT',
]);

export const DirectSaleActivityResponseBodySchema = z.object({
  id: z.string().uuid(),
  subject: z.string().nullable(),
  activityType: z.enum([
    ...DirectSaleManualActivityKindSchema.options,
    'TASK_CREATED',
    'TASK_FINISHED',
    'EMAIL_TO_CUSTOMER',
    'SMS_TO_CUSTOMER',
    'WHATSAPP_TO_CUSTOMER',
    'TELEPHONY_INBOUND_CALL',
    'TELEPHONY_OUTBOUND_CALL',
  ]),
  userId: z.string().nullable(),
  userName: z.string(),
  timestamp: z.string().datetime({offset: true}),
  description: z.string().nullable(),
  isEditable: z.boolean(),
  relatedTask: SalesActivityRelatedTaskResponseBodySchema.nullable(),
  relatedMessage: SalesActivityRelatedMessageResponseBodySchema.extend({
    sender: z.object({
      name: z.string().nullable(),
      email: z.string().nullable(),
    }),
  }).nullable(),
  relatedCall: SalesActivityRelatedCallResponseBodySchema.nullish(),
});
export type DirectSaleActivityResponseBody = z.infer<typeof DirectSaleActivityResponseBodySchema>;

export const CreateDirectSaleActivityRequestBodySchema = z.object({
  activityType: DirectSaleManualActivityKindSchema,
  createdAt: z.string(),
  subject: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
});
export type CreateDirectSaleActivityRequestBody = z.infer<
  typeof CreateDirectSaleActivityRequestBodySchema
>;

export const PatchDirectSaleActivityRequestBodySchema =
  CreateDirectSaleActivityRequestBodySchema.partial();
export type PatchDirectSaleActivityRequestBody = z.infer<
  typeof PatchDirectSaleActivityRequestBodySchema
>;
